import React, { useEffect, useState } from "react";
import { Flame, Quote } from "lucide-react";
import api from "../lib/api";
import { useMT } from "../lib/miniI18n";

/* Me page: top proverb-card sharers this week + my rank */
export function StreakLeaderboard() {
  const [d, setD] = useState(null);
  const mt = useMT();
  useEffect(() => { api.get("/proverbs/leaderboard").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div className="rl-card p-4" data-testid="streak-leaderboard">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-display font-bold text-slate-900 text-sm flex items-center gap-1.5"><Quote className="w-4 h-4 text-amber-500" />{mt("Top Sharers This Week")}</h3>
        <span className="text-[10px] font-bold text-orange-600 bg-orange-50 border border-orange-200 rounded-full px-2 py-0.5 flex items-center gap-1" data-testid="streak-my-rank"><Flame className="w-3 h-3" />{d.my_rank ? `#${d.my_rank} · ${d.my_shares}` : mt("Share to rank")}</span>
      </div>
      {!d.top.length ? <div className="text-xs text-slate-400" data-testid="streak-empty">{mt("Be the first to share today's proverb card")}</div> : (
        <div className="space-y-1.5">
          {d.top.map((r) => (
            <div key={r.rank} className={`flex items-center gap-2 rounded-xl px-2.5 py-1.5 ${r.is_me ? "bg-amber-50 border border-amber-200" : "bg-slate-50"}`} data-testid={`streak-row-${r.rank}`}>
              <span className="w-6 text-center text-sm">{r.medal || <span className="text-[11px] font-bold text-slate-400">#{r.rank}</span>}</span>
              <span className="flex-1 text-xs font-semibold text-slate-800 truncate">{r.name}{r.is_me ? ` (${mt("you")})` : ""} <span className="text-[10px] text-slate-400 font-normal">{r.mobile_masked}</span></span>
              {r.streak > 0 && <span className="text-[10px] font-bold text-orange-600 flex items-center gap-0.5"><Flame className="w-3 h-3" />{r.streak}</span>}
              <span className="text-xs font-mono font-black text-slate-900 w-6 text-right">{r.shares}</span>
            </div>
          ))}
        </div>
      )}
      <div className="text-[10px] text-slate-400 mt-2">{mt("Shares this week")} · {d.participants} {mt("players")}</div>
    </div>
  );
}
